module.exports = __webpack_public_path__ + "static/media/kidd.b2d2046c.png";